export function NotFound() {
  return <p>Page not found</p>;
}
